import { render, staticRenderFns } from "./ContactDetailWindow.vue?vue&type=template&id=2a93cb68&scoped=true&"
import script from "./ContactDetailWindow.vue?vue&type=script&lang=js&"
export * from "./ContactDetailWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93cb68",
  null
  
)

export default component.exports